import { render, staticRenderFns } from "./TicketTemplateSettings.vue?vue&type=template&id=7fa03d2d&scoped=true"
import script from "./TicketTemplateSettings.vue?vue&type=script&lang=js"
export * from "./TicketTemplateSettings.vue?vue&type=script&lang=js"
import style0 from "./TicketTemplateSettings.vue?vue&type=style&index=0&id=7fa03d2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa03d2d",
  null
  
)

export default component.exports